<template>
  <div class="page">
    <Header
      :pageTitle = 'getPageStoreData.titel'
      schema="default"
    />
    <b-container class="pb-1">
      <Breadcrumb
        :pathToPage="pathToThisPage"
      />
      <b-row
        v-if="getPageStoreData"
      >
        <b-col
          sm=12
        >
          <div
            v-html="normalize(getPageStoreData.body)"
          />
          <div
            v-if="$route.params.page === 'techchecks'"
          >
            <h2>Edit-Mode</h2>
            <b-form
              v-if="!$store.state.editMode"
              @submit.prevent="submitEditMode()"
              class="w-50"
            >
              <b-form-input type="password" placeholder="Freischaltcode" v-model="code" class="my-2 small" />
              <b-button type="submit" >Edit Mode einschalten</b-button>
            </b-form>
            <b-form
              v-else
              @submit.prevent="cancelEditMode()"
              class="w-50"
            >
              <b-button type="submit" >Edit-Mode ausschalten</b-button>
            </b-form>

            <!-- <p
              class="mb-2"
            >
              <b-button
                @click="localSwitchLanguage('en')"
              >
                Sprache wechseln zu EN
              </b-button>
            </p>
            <p
              class="mb-2"
            >
              <b-button
                @click="localSwitchLanguage('ru')"
              >
                Sprache wechseln zu RU
              </b-button>
            </p>
            <p
              class="mb-2"
            >
              <b-button
                @click="localSwitchLanguage('de')"
              >
                Sprache wechseln zu DE
              </b-button>
            </p> -->
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div><!-- .homepage -->
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Header from '@/components/Header.vue'
import Breadcrumb from '@/components/subparts/Breadcrumb-subpart.vue'
import initView from '../mixins/initView'

export default {
  name: 'page',
  components: {
    Header,
    Breadcrumb
  },
  mixins: [
    initView
  ],
  data () {
    return {
      hbg: '',
      slug: '',
      code: ''
    }
  },
  computed: {
    ...mapGetters({
      homeData: 'getHomeData',
      lang: 'getLanguage',
      navigation: 'getNavigation',
      getPageStoreData: 'getPageStoreData',
      newRoute: 'getNewRoute'
    }),
    pathToThisPage () {
      let path = []
      let nav = this.$store.state.navigation
      let lang = this.$store.state.lang

      path[0] = {
        name: nav.home.navTitle[lang],
        slug: '/',
        disabled: false
      }
      path[1] = {
        name: this.getPageStoreData.navTitel,
        slug: '',
        disabled: true
      }
      return path
    }
  },
  methods: {
    ...mapActions({
      setCurrentPage: 'setCurrentPage',
      switchLanguage: 'switchLanguage',
      setEditMode: 'setEditMode'
    }),
    submitEditMode () {
      this.setEditMode(this.code)
      if (this.$store.state.editMode) {
        this.$router.push('/medien/videos')
      }
      this.code = ''
    },
    cancelEditMode () {
      this.$store.state.editMode = ''
      sessionStorage.removeItem('editModeCode')
      this.$router.push('/medien/videos')
    },
    localSwitchLanguage (lang) {
      this.switchLanguage(lang)
    },
    fetchData () {
      this.slug = this.$route.params.page
    },
    setData () {
      this.setCurrentPage(this.$route.params.page)
    }
  },
  created () {
    this.fetchData()
    this.setData()
  },
  watch: {
    // call again the method if the route changes
    '$route': 'setData'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
